module.exports = __webpack_public_path__ + "static/media/air-pollution.b426de86.svg";